module.exports = __webpack_public_path__ + "static/Basketball-f7df486fdf016069b81e3da9acedf14e.mp4";